import { Link } from "react-router-dom";
import { BOM } from "../../services/definedMethod";

export const apiConfig = {
  GetAuctions: BOM.baseUrl("treasury", "treasury"),
  GetTrades: BOM.baseUrl("treasury", "treasury"),
  GetSettlements: BOM.baseUrl("treasury", "treasury"),
  GetTreasuryBillContract: BOM.baseUrl("treasurybillcontracts", "treasury"),
  GetBondContracts: BOM.baseUrl("bondcontracts", "treasury"),
  GetClients: BOM.baseUrl("clients"),
};

export const labelConfig = {
  auction: "Auction",
  auctionListing: "Auction Listing",
  addAuction: "Create New Aution",
  editAuction: "Edit Auction",
  viewAuction: "View Auction",
  addAuctionLine:"Add Auction Line",
  convertTradeToAllotment:"Convert Trade To allotment",

  trade: "Trade",
  tradeListing: "Trade Listing",
  addTrade: "Create New Trade",
  editTrade: "Edit Trade",
  viewTrade: "View Trade",

  settlement:"Settlement",
  settlementListing:"Settlement Listing",
  addSettlement:"Settlement Listing",
  editSettlement:"Edit Settlement",
  viewSettlement:"View Settlement",

  treasuryBillContract:"Treasury Bill Contract",
  treasuryBillContractListing:"Treasury Bill Contract Listing",
  addTreasuryBillContractListing:"Create Treasury Bill Contract Listing",
  viewTreasuryBillContractListing:"View Treasury Bill Contract Listing",

  manageBondContract:"Bond Contract",
  bondContractListing:"Bond Contract",
  addBondContractListing:"Add Bond  Contract Listing",
  viewBondContractListing:"View Bond Contract Listing",

};

export const staticConfig = {
  manageAuction: [{ title: labelConfig.auction }],
  newAuction: [
    { title: <Link to="/auction">{labelConfig.auction}</Link> },
    {
      title: labelConfig.addAuction,
    },
  ],
  viewAuction: [
    { title: <Link to="/auction">{labelConfig.auction}</Link> },
    {
      title: labelConfig.viewAuction,
    },
  ],
  addAuctionLine: [
    { title: <Link to="/auction">{labelConfig.auction}</Link> },
    {
      title: labelConfig.addAuctionLine,
    },
  ],

  manageTrade: [{ title: labelConfig.trade }],
  newTrade:[
    { title: <Link to="/trade">{labelConfig.trade}</Link> },
    {
      title: labelConfig.addTrade,
    },
  ],
  viewTrade:[
    { title: <Link to="/trade">{labelConfig.trade}</Link> },
    {
      title: labelConfig.viewTrade,
    },
  ],
  
  manageSettlement: [{ title: labelConfig.settlement }],
  newSettlement:[
    { title: <Link to="/settlement">{labelConfig.settlement}</Link> },
    {
      title: labelConfig.addSettlement,
    },
  ],
  viewSettlement:[
    { title: <Link to="/settlement">{labelConfig.settlement}</Link> },
    {
      title: labelConfig.viewSettlement,
    },
  ],
  
  managetreasuryBillContract: [{ title: labelConfig.treasuryBillContract }],
  newtreasuryBillContract:[
    { title: <Link to="/treasury-bill-contract">{labelConfig.treasuryBillContract}</Link> },
    {
      title: labelConfig.addTreasuryBillContractListing,
    },
  ],
  viewtreasuryBillContract:[
    { title: <Link to="/treasury-bill-contract">{labelConfig.treasuryBillContract}</Link> },
    {
      title: labelConfig.viewTreasuryBillContractListing,
    },
  ],
  manageBondContract: [{ title: labelConfig.manageBondContract }],
  newBondContract:[
    { title: <Link to="/bond-contract">{labelConfig.addBondContractListing}</Link> },
    {
      title: labelConfig.viewBondContractListing,
    },
  ],
  viewBondContract:[
    { title: <Link to="/bond-contract">{labelConfig.addBondContractListing}</Link> },
    {
      title: labelConfig.viewBondContractListing,
    },
  ]
  
};
